module.exports = __webpack_public_path__ + "img/Stere.362125d6.jpg";